import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f84c331e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c331e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84c331e')) {
      api.createRecord('f84c331e', component.options)
    } else {
      api.reload('f84c331e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f84c331e&scoped=true&", function () {
      api.rerender('f84c331e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yQIi04pO0KJp/JS/comp/SearchFilterTokens.vue"
export default component.exports